// Jewels Park – Dynamic Pricing based on Cart Total v2
// Slabs: <$5000 = 30%, $5000-$10000 = 40%, $10000+ = 50%
// Works on both product page and collection page cards

(function () {

  const SLABS = [
    { min: 0,     max: 4999.99,  pct: 30 },
    { min: 5000,  max: 9999.99,  pct: 40 },
    { min: 10000, max: Infinity, pct: 50  }
  ];

  // ── Inject styles ──────────────────────────────
  const style = document.createElement('style');
  style.textContent = `
    .jp-slab-line {
      display: block;
      padding: 4px 8px;
      border-radius: 4px;
      transition: background 0.3s, color 0.3s, font-weight 0.3s;
      font-size: 13px;
    }
    .jp-slab-line.jp-slab-active {
      background: #1a1a1a;
      color: #fff;
      font-weight: 600;
    }
    .jp-slab-line.jp-slab-inactive {
      color: #999;
    }
  `;
  document.head.appendChild(style);

  // ── Helpers ────────────────────────────────────
  function formatPrice(amount) {
    return '$' + amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function parsePrice(text) {
    return parseFloat((text || '').replace(/[^0-9.]/g, ''));
  }

  function getActiveSlab(cartOriginalTotal) {
    let slab = SLABS[0];
    for (let i = SLABS.length - 1; i >= 0; i--) {
      if (cartOriginalTotal >= SLABS[i].min) { slab = SLABS[i]; break; }
    }
    return slab;
  }

  // ── Product page: parse slab text into spans ───
  function buildSlabLines() {
    const textEl = document.querySelector('.m-product-text');
    if (!textEl) return;
    const raw   = textEl.innerHTML;
    const lines = raw.split(/<br\s*\/?>/i).map(function (l) { return l.trim(); }).filter(Boolean);
    if (lines.length < 2) return;
    textEl.innerHTML = lines.map(function (line, i) {
      return '<span class="jp-slab-line" data-slab="' + i + '">' + line + '</span>';
    }).join('');
  }

  // ── Product page: update price + badge + slab highlight ──
  function updateProductPage(slab) {
    const regularEl = document.querySelector('.m-price__regular .m-price-item--regular');
    if (!regularEl) return;
    const basePrice = parsePrice(regularEl.textContent);
    if (!basePrice) return;

    const discounted = basePrice * (1 - slab.pct / 100);

    const salePriceEl = document.querySelector('.m-price__sale .m-price-item--sale');
    if (salePriceEl) salePriceEl.textContent = formatPrice(discounted);

    const badgeEl = document.querySelector('.jp-discount-text');
    if (badgeEl) badgeEl.textContent = '-' + slab.pct + '% OFF';

    document.querySelectorAll('.jp-slab-line').forEach(function (line, i) {
      line.classList.toggle('jp-slab-active', i === SLABS.indexOf(slab));
      line.classList.toggle('jp-slab-inactive', i !== SLABS.indexOf(slab));
    });
  }

  // ── Collection page: update all card prices ────
  function updateCollectionCards(slab) {
    document.querySelectorAll('.m-product-card').forEach(function (card) {
      // Get compare-at (retail/original) price from card
      const regularEl = card.querySelector('.m-price__regular .m-price-item--regular');
      if (!regularEl) return;
      const basePrice = parsePrice(regularEl.textContent);
      if (!basePrice) return;

      const discounted = basePrice * (1 - slab.pct / 100);

      // Update sale price
      const salePriceEl = card.querySelector('.m-price__sale .m-price-item--sale');
      if (salePriceEl) salePriceEl.textContent = formatPrice(discounted);

      // Update discount badge on card (jp-discount-text injected by product-card liquid)
      const badgeEl = card.querySelector('.jp-discount-text');
      if (badgeEl) badgeEl.textContent = '-' + slab.pct + '% OFF';

      // Update spec card divider discount if visible
      const specBadge = card.querySelector('.js-card__badge');
      if (specBadge) specBadge.textContent = slab.pct + '% off';
    });
  }

  // ── Fetch cart and run updates ─────────────────
  function recalculate() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Use original_total_price (before discounts) to determine slab
        const cartOriginalTotal = (cart.original_total_price || cart.total_price) / 100;
        const slab = getActiveSlab(cartOriginalTotal);

        // Update product page if on one
        if (document.querySelector('.main-product__block-price')) {
          updateProductPage(slab);
        }

        // Update collection cards if present
        if (document.querySelectorAll('.m-product-card').length > 0) {
          updateCollectionCards(slab);
        }
      })
      .catch(function (err) {
        console.warn('JewelsPark pricing: cart fetch failed', err);
      });
  }

  // ── Watch for cart changes ─────────────────────
  function watchCartChanges() {
    // Intercept fetch to /cart/add
    const origFetch = window.fetch;
    window.fetch = function () {
      const url    = arguments[0];
      const result = origFetch.apply(this, arguments);
      if (typeof url === 'string' && url.includes('/cart/add')) {
        result.then(function () { setTimeout(recalculate, 500); });
      }
      return result;
    };

    // Minimog custom events
    document.addEventListener('cart:updated',   function () { setTimeout(recalculate, 300); });
    document.addEventListener('theme:cart:add', function () { setTimeout(recalculate, 300); });

    // XHR fallback
    const origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (url && url.includes('/cart/add')) {
        this.addEventListener('load', function () { setTimeout(recalculate, 500); });
      }
      return origOpen.apply(this, arguments);
    };
  }

  // ── Init ───────────────────────────────────────
  function init() {
    buildSlabLines();  // product page slab lines
    recalculate();     // run immediately on load
    watchCartChanges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when user navigates back (bfcache restore)
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      // Page was restored from bfcache — re-run recalculate
      buildSlabLines();
      recalculate();
    }
  });

})();